// extracted by mini-css-extract-plugin
module.exports = {"sectionPeople":"cl_hz","listSquare":"cl_bp","imgPeople":"cl_hB","sectionHeader":"cl_bb","rightColumn":"cl_dc","rightSubtitle":"cl_hC","list":"cl_bn"};